import * as actionTypes from './actionTypes';
import axios from 'axios';

export const addChatMsgEnquirySettlement = (payload) => {
    return({
        type: actionTypes.ADD_Chat_MSG_EnquirySettlement,
        username: payload.username,
        content: payload.content,
        timestamp: payload.timestamp,
    });
}

export const errorAddChatMsgEnquirySettlement = () => {
    return({
        type: actionTypes.Error_ADD_Chat_MSG_EnquirySettlement,
        addChatEnquirySettlementError: true,
    });
}

export const errorGetAllMsgEnquirySettlement = () => {
    return({
        type: actionTypes.ERROR_GET_ALL_CHAT_MSG_EnquirySettlement,
        getChatEnquirySettlementError: true,
    });
}

export const getAllChatMsgsEnquirySettlement = (payload) => {
    return({
        type: actionTypes.GET_ALL_CHAT_MSGS_EnquirySettlement,
        payloadEnquirySettlement: payload,
    });
}

export const saveChatMsgEnquirySettlement = (payload) => {
    console.log('**saveChatMsgEnquirySettlement called');
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/SaveChatMsgEnquirySettlement`;

    return (dispatch) => {
        axios.post(url, payload)
        .then((response) => {
            // console.log(response);
            console.log('saveChatMsgEnquirySettlement response: '+JSON.stringify(response))
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            // dispatch(addChatMsgEnquirySettlement(response.data));
            dispatch(getAllChatMsgEnquirySettlement(payload.caseId))
        })
        .catch((error) => {
            console.log(error);
            dispatch(errorAddChatMsgEnquirySettlement());
        });
    }
}

export const getAllChatMsgEnquirySettlement = (caseId) => {
    console.log('**getAllChatMsgEnquirySettlement called')
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/GetAllChatMsgEnquirySettlement`;

    return (dispatch) => {
        axios.post(url, {caseId:caseId})
        .then((response) => {
            // console.log(response);
            console.log('**getAllChatMsgEnquirySettlement response: '+JSON.stringify(response))
            if(response.data === 'error' || response.data === 'failed'){
                dispatch(getAllChatMsgsEnquirySettlement([]));
                dispatch(errorAddChatMsgEnquirySettlement());
            }
            dispatch(getAllChatMsgsEnquirySettlement(response.data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(errorAddChatMsgEnquirySettlement());
        });
    }
}

export const clearAllChatMsgEnquirySettlement = () => {
    console.log('**clearAllChatMsgEnquirySettlement called')
    return (dispatch) => {
        dispatch(getAllChatMsgsEnquirySettlement([]));
    }
}

export const editChatMsgEnquirySettlement = (payload) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/EditChatMsgEnquirySettlement`;

    return (dispatch) => {
        axios.post(url, payload)
        .then((response) => {
            if (response.data === 'error' || response.data === 'failed' || response.data === 'forbidden') {
                throw (`editChatMsgEnquirySettlement ${response.data}`);
            }
            dispatch(getAllChatMsgEnquirySettlement(payload.caseId));
        })
        .catch((error) => {
            console.log(error);
            dispatch(errorAddChatMsgEnquirySettlement());
        });
    }
}

export const deleteChatMsgEnquirySettlement = (payload) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/DeleteChatMsgEnquirySettlement`;

    return (dispatch) => {
        axios.post(url, payload)
        .then((response) => {
            if (response.data === 'error' || response.data === 'failed' || response.data === 'forbidden') {
                throw (`deleteChatMsgEnquirySettlement ${response.data}`);
            }
            dispatch(getAllChatMsgEnquirySettlement(payload.caseId));
        })
        .catch((error) => {
            console.log(error);
            dispatch(errorAddChatMsgEnquirySettlement());
        });
    }
}

export const clearManagedChatMsgEnquirySettlement = (payload) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/ClearManagedChatMsgEnquirySettlement`;

    return (dispatch) => {
        axios.post(url, payload)
        .then((response) => {
            if (response.data === 'error' || response.data === 'failed' || response.data === 'forbidden') {
                throw (`clearManagedChatMsgEnquirySettlement ${response.data}`);
            }
            dispatch(getAllChatMsgEnquirySettlement(payload.caseId));
        })
        .catch((error) => {
            console.log(error);
            dispatch(errorAddChatMsgEnquirySettlement());
        });
    }
}